import { defineAsyncComponent } from 'vue'
export default {
  main: defineAsyncComponent(() => import("C:/Users/csb/Documents/GitHub/RiggingCalculator/layouts/main.vue").then(m => m.default || m))
}